var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24.3945 26.834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2216 2.43945C19.1497 2.43945 24.3945 8.11969 24.3945 14.6184C24.3945 22.1554 18.2471 26.834 12.1973 26.834C10.1969 26.834 7.977 26.2965 6.1962 25.2459C5.57414 24.8673 5.04966 24.5863 4.37881 24.8062L1.91497 25.5391C1.29291 25.7346 0.731835 25.2459 0.914794 24.5863L1.73201 21.85C1.86618 21.4713 1.84179 21.0682 1.64663 20.7506C0.597665 18.8205 0 16.7072 0 14.655C0 8.22963 5.13504 2.43945 12.2216 2.43945ZM17.7958 13.1036C16.9298 13.1036 16.2345 13.7999 16.2345 14.6672C16.2345 15.5223 16.9298 16.2308 17.7958 16.2308C18.6618 16.2308 19.357 15.5223 19.357 14.6672C19.357 13.7999 18.6618 13.1036 17.7958 13.1036ZM12.1729 13.1036C11.3191 13.0914 10.6116 13.7999 10.6116 14.655C10.6116 15.5223 11.3069 16.2186 12.1729 16.2308C13.0389 16.2308 13.7341 15.5223 13.7341 14.6672C13.7341 13.7999 13.0389 13.1036 12.1729 13.1036ZM6.54993 13.1036C5.68392 13.1036 4.98868 13.7999 4.98868 14.6672C4.98868 15.5223 5.69612 16.2308 6.54993 16.2308C7.41593 16.2186 8.11117 15.5223 8.11117 14.6672C8.11117 13.7999 7.41593 13.1036 6.54993 13.1036Z",
    fill: "var(--fill-0, #5D7285)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 19.5156,
    cy: 4.8789,
    r: 4.8789,
    fill: "var(--fill-0, #2196F3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8a9c413654ed52d1d069e174e14755d1.svg";
export { ForwardRef as ReactComponent };